import React from 'react';
import '../../App.css';

export default function Login() {
    return <h1 className='login'>LOGIN</h1>;
    
}